export enum FacetCategory {
  ProductionType = "Production type",
  ContractType = "Contract types",
  Appearance = "Appearance",
  Gender = "Gender",
  Disability = "Disability",
  ComplaintCategory = "Complaint categories",
  Location = "Location",
  HeritageAndEthnicity = "Heritage And Ethnicity",
  EthnicBackground = "Ethnic Background",
}

export interface IFacet {
  id: number;
  name: string;
  code: string;
  orderKey?: number;
}

export interface IFacetGroup {
  id: number;
  name: string;
  code: string;
  facets: IFacet[];
}

export interface IFacetCategory {
  id: number;
  maxActiveCount: number;
  name: string;
  systemName: string;
  code: string;
  facetGroups: IFacetGroup[];
}
